export default {
  RESIGN: "resign",
  TRANSFER: "transfer",
  OTHER_CHARGES: "other_charges",
};
